<template>
  <span style="">
    <modal-tooltip
      :show="showModal"
      @close="showModal = false"
      :text-a="textA"
      :text-b="textB"
      :title="title"
    />
    <a href="#" style="text-decoration: none" >
      <span class="icon-info_sign" style="color:black; font-size:Small; margin-left:4px " @click.prevent="showModal = true" ></span>
    </a>
  </span>
</template>

<script>
import ModalTooltip from './ModalTooltip'
export default {
  name: 'InfoIconWithExplanationModal',
  props: ['title', 'textA', 'textB'],
  components: {
    ModalTooltip
  },
  data () {
    return {
      showModal: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InfoIconWithExplanationModal.vue